import { render, staticRenderFns } from "./ApprEdit.vue?vue&type=template&id=27be9987&scoped=true&"
import script from "./ApprEdit.vue?vue&type=script&lang=js&"
export * from "./ApprEdit.vue?vue&type=script&lang=js&"
import style0 from "./ApprEdit.vue?vue&type=style&index=0&id=27be9987&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27be9987",
  null
  
)

export default component.exports